<template>
  <div id="app">
    <!-- <transition name="slide" mode="out-in"> -->
    <!-- <div :is="currentView" class="page"> -->
    <top-nav />

    <!-- </div> -->
    <!-- </transition> -->
    <div class="home">
      <router-view name="home" />
    </div>
    <div class="warehouse">
      <router-view name="warehouse" />
    </div>
    <div class="gygd">
      <router-view name="gygd" />
    </div>
    <div class="notFound">
      <router-view name="unfound" />
    </div>
    <div class="news">
      <router-view name="news" />
    </div>
    <div class="recruit">
      <router-view name="recruit" />
    </div>
    <div class="contactus">
      <router-view name="contactus" />
    </div>
    <div class="shop">
      <router-view name="shop" />
    </div>
    <div class="indexnews">
      <router-view name="indexnews" />
    </div>
    <div class="indexnotice">
      <router-view name="indexnotice" />
    </div>
    <xiabiao />
    <Footer />
  </div>
</template>

<script>
import topNav from './components/top-nav.vue'
import Footer from './components/foot.vue'
import xiabiao from "./components/xiabiao.vue";
export default {
  data() {
    return {
      // currentView: 'Page1',
      // pages: ['Page1', 'recentnews', 'overview', 'aboutus', 'home'],
      // currentPageIndex: 0, // 当前组件索引
      // scrollY: 0,
      // isScrollingToTarget:false,
    }
  },
  components: {
    topNav,Footer,
    xiabiao
  },
  methods: {
    // handleScroll() {
    //   this.scrollY = window.scrollY || document.documentElement.scrollY || document.body.scrollY || 0;
    //   console.log(this.scrollY);
    //   if (this.scrollY === 821 || this.isScrollingToTarget) {
    //     return;
    //   }

    //   if (this.scrollY > 0 && this.scrollY <= 821) {
    //     window.scrollTo({ top: 821, behavior: 'smooth' })
    //     setTimeout(() => {
    //       this.isScrollingToTarget = false;
    //     }, 1000);
    //   }
    //   else if(this.scrollY > 821 && this.scrollY <= 1660) {
    //     window.scrollTo({ top: 1660, behavior: 'smooth' })
    //     setTimeout(() => {
    //       this.isScrollingToTarget = false;
    //     }, 1000);
    //   }
    //   else if(this.scrollY > 1660 && this.scrollY <= 2460) {
    //     window.scrollTo({ top: 2460, behavior: 'smooth' })
    //     setTimeout(() => {
    //       this.isScrollingToTarget = false;
    //     }, 1000);
    //   }
    //   else if(this.scrollY > 2460 && this.scrollY <= 3295) {
    //     window.scrollTo({ top: 3295, behavior: 'smooth' })
    //     setTimeout(() => {
    //       this.isScrollingToTarget = false;
    //     }, 1000);
    //   }
    // },
    // handleWheel(event) {
    //   if (event.deltaY < 0 && this.scrollY > 0) { // 向上滚动且当前不在顶部


    //     const step = 0; // 每次滚动的步长
    //     const newScrollPosition = Math.max(this.scrollY - step, 0);

    //     window.scrollTo({ top: newScrollPosition, behavior: 'smooth' });

    //     this.scrollY = newScrollPosition;
    //     event.preventDefault(); // 阻止默认滚动行为
    //   }
    // },
    // scrollToTop() {
    //   window.scrollTo({ top: 0, behavior: 'smooth' });
    // }
  //   handleScroll(event) {
  //     if (event.deltaY > 0) {
  //       // 向下滚动
  //       if (this.currentPageIndex < this.pages.length - 1) {
  //         this.currentPageIndex++;
  //         this.currentView = this.pages[this.currentPageIndex];
  //       }
  //     } else {
  //       // 向上滚动
  //       if (this.currentPageIndex > 0) {
  //         this.currentPageIndex--;
  //         this.currentView = this.pages[this.currentPageIndex];
  //       }
  //     }
  //   }
  },
}
</script>

<style scoped>
.page {
  width: 100%;
  height: 100vh; /* 视窗高度 */
  /* position: absolute; 确保页面覆盖而不是堆叠 */
  /* top: 0;
  left: 0; */
}
/* 定义 smooth 过渡效果 */
.smooth-enter-active, .smooth-leave-active {
  transition: all 1s ease;
}
.smooth-enter, .smooth-leave-to /* .smooth-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(100px);
}
.page {
  width: 100%;
  height: 100vh; /* 视窗高度 */
  position: absolute; /* 确保页面覆盖而不是堆叠 */
  top: 0;
  left: 0;
}
</style>

<style>
  .el-menu--popup-bottom-start{
    min-width: 171px!important;
    text-align: center;
  }
</style>